export default __webpack_public_path__ + "locales/el-GR/People.json?hash=fed16cc6ee3c83b68977b374a27e5b7d";